import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "types"
import { useApi } from "utils"

export const useDropdownVendor = () => {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(true)

  const refetch = () => {
    setLoading(true)
    api.get("/vendor/")
    .then((res: SuccessFetch<{ payload: { 
        vendor_id: number, 
        vendor_name: string }[] 
      }>) => { 

      setData(res.data.payload.map(item => {
         return { 
          label: item.vendor_name, 
          value: item.vendor_id.toString() 
        }}))
    })
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }


  useEffect(() => {
    refetch()
  
    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}